import { ApiResponse } from "apisauce";
import { Api } from "./api";
import { getGeneralApiProblem } from "./api-problem";

export class ReportsApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getReports(): Promise<any> {
    try {
      const response: ApiResponse<never> = await this.api.apisauce.get(
        `report`
      );
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const { data } = response;
      return data;
    } catch (error) {
      return { kind: "bad-data" };
    }
  }

  async getReport(reportId: string): Promise<any> {
    try {
      const response: ApiResponse<never> = await this.api.apisauce.get(`report/${reportId}`);
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const { data } = response;
      return data;
    } catch (error) {
      return { kind: "bad-data" };
    }
  }
}
